/**
 * 随手记客户端相关处理
 * 说明：处理随手记客户端内相关协议，包括以下功能【更新后请依次填写】
 * 1、获取随手记客户端设备号
 */


import clientBridge from '@common/client/src/bridge'
import useragent from '@common/useragent'

// 获取设备信息
const getClientInfo = () => {
  return new Promise((resolve, reject) => {
    clientBridge.call(clientBridge.uriSuishouji('requestClientInfo', {}, 'onClientInfoResult'), 'onClientInfoResult', (result) => {
      const _result = JSON.parse(result)
      console.log('Collect Suishouji Data:', _result)
      if (_result.success) {
        resolve(_result)
      } else {
        reject('获取随手记客户端信息失败')
      }
    })
  })
}

export default class SuishoujiClient {
  static clientInfo = null
  async getClientInfo() {
    if (!this.clientInfo) {
      try {
        const result = await getClientInfo()
        this.clientInfo = result.result
      } catch (error) {
        console.warn('Collect Suishouji Error:', error)
      }
    }
    // 因安卓版客户端返回的数据有问题，需要兼容一下
    if (useragent.isAndroid && this.clientInfo) {
      const FDMarketMeta = window.FDMarketMeta || window.FDMarketMetaNew || {}
      this.clientInfo.AppVersion = this.clientInfo.AppName
      this.clientInfo.AppName = FDMarketMeta.AppName || 'android-mymoney'
    }
    return {
      appName: this.clientInfo ? this.clientInfo.AppName : '',
      appVersion: this.clientInfo ? this.clientInfo.AppVersion : '',
      channel: this.clientInfo ? this.clientInfo.PartnerCode : '',
      udid: this.clientInfo ? this.clientInfo.UUID : '',
      idfa: this.clientInfo ? this.clientInfo.idfa : '',
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/@finance/ssvue/node_modules/@common/collect/src/client/suishouji.js